

import __layout_0 from '/app/resources/ts/layouts/default.vue'
export const layouts = {
'blank': () => import('/app/resources/ts/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithHorizontalNav': () => import('/app/resources/ts/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/app/resources/ts/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/app/resources/ts/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/app/resources/ts/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/app/resources/ts/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/app/resources/ts/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/app/resources/ts/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/app/resources/ts/layouts/components/UserProfile.vue'),
}
export const createGetRoutes = (router, withLayout = false) => {
  const routes = router.getRoutes()
  if (withLayout) {
      return routes
  }
  return () => routes.filter(route => !route.meta.isLayout)
}

export function setupLayouts(routes) {
  function deepSetupLayout(routes, top = true) {
    return routes.map(route => {
      if (route.children?.length > 0) {
        route.children = deepSetupLayout(route.children, false)
      }
      
      if (top) {
        // unplugin-vue-router adds a top-level route to the routing group, which we should skip.
        const skipLayout = !route.component && route.children?.find(r => (r.path === '' || r.path === '/') && r.meta?.isLayout)  

        if (skipLayout) {
          return route
        }

        if (route.meta?.layout !== false) {
          return { 
            path: route.path,
            component: layouts[route.meta?.layout || 'default'],
            children: route.path === '/' ? [route] : [{...route, path: ''}],
            meta: {
              isLayout: true
            }
          }
        }
      }

      if (route.meta?.layout) {
        return { 
          path: route.path,
          component: layouts[route.meta?.layout],
          children: [ {...route, path: ''} ],
          meta: {
            isLayout: true
          }
        }
      }

      return route
    })
  }

    return deepSetupLayout(routes)

}
